
import { Options, Prop, Vue } from 'vue-property-decorator'

@Options({
  name: 'User'
})
export default class User extends Vue {}
